import Vue from "vue";
import App from "./App.vue";
import Router from "vue-router";
import Portfolio from "./components/Portfolio";
import PortfolioItem from "./components/PortfolioItem";

Vue.use(Router);

Vue.config.productionTip = false;

const router = new Router({
  base: "/",
  mode: "history",
  routes: [
    { path: "/", component: Portfolio, params: "index" },
    { path: "/:id", component: PortfolioItem },
    { path: "/:pathMatch(.*)*", redirect: "/" }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
